import {
  FETCHING_USER_ACCOUNT_REQUEST, FETCHING_USER_ACCOUNT_SUCCEDDED, FETCHING_USER_ACCOUNT_FAILED,
  FETCHING_USER_PROFILE, FETCHING_USER_PROFILE_SUCCEEDED, FETCHING_USER_PROFILE_FAILED, FETCHING_NOTIFICATIONS, FETCHING_NOTIFICATIONS_SUCCEEDED, FETCHING_NOTIFICATIONS_FAILED, LOGOUT_USER
} from 'constants/actionTypes';

import axios from 'axios';
import { createAction } from 'redux-actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import AuthService from 'services/auth.service';

const apiUrl = process.env.REACT_APP_API_URL;
const usersApi = process.env.REACT_APP_USERS_API_URL;

const BASE_URL = `${apiUrl}/api/2.0`
const AUTHORIZE_URL = `${usersApi}/users/3.0/oauth/token`;
const PROFILE_URL = `${usersApi}/users/3.0/me`;
const ACCOUNT_BASE_URL = `${BASE_URL}/accounts`;
const notificationUrl = `${apiUrl}/api/2.1/notifications`
/**
* User Account
*/
export const fetchUserAccount = createAction(FETCHING_USER_ACCOUNT_REQUEST);
const fetchingUserAccountSuccedded = createAction(FETCHING_USER_ACCOUNT_SUCCEDDED);
const fetchingUserAccountFailed = createAction(FETCHING_USER_ACCOUNT_FAILED);

function* fetchUserAccountSaga() {

  const fetchUserAccountAPI = () => {
    return axios.get(ACCOUNT_BASE_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchUserAccountAPI);
    yield put(fetchingUserAccountSuccedded(response));
  } catch (error) {
    yield put(fetchingUserAccountFailed(error));
  }
}

/**
* User Profile
*/
export const fetchUserProfile = createAction(FETCHING_USER_PROFILE);
const fetchingUserProfileSuccedded = createAction(FETCHING_USER_PROFILE_SUCCEEDED);
const fetchingUserProfileFailed = createAction(FETCHING_USER_PROFILE_FAILED);

function* fetchUserProfileSaga() {

  const fetchUserProfileAPI = () => {
    return axios.get(PROFILE_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchUserProfileAPI);
    yield put(fetchingUserProfileSuccedded(response));
  } catch (error) {
    yield put(fetchingUserProfileFailed(error));
  }
}


/**
 * Notifications
 */

export const fetchNotification = createAction(FETCHING_NOTIFICATIONS);
const fetchNotificationSucceeded = createAction(FETCHING_NOTIFICATIONS_SUCCEEDED);
const fetchNotificationFailed = createAction(FETCHING_NOTIFICATIONS_FAILED);

function* fetchNotificationSaga(action) {

  const page  = action.payload 

  const data = {
    page
  }

  const fetchNotificationApi = () => {
    return axios({
      method: 'GET',
      url: notificationUrl,
      params: data
    }).then(response => response.data);
  }

  try {
    const response = yield call(fetchNotificationApi);
    yield put(fetchNotificationSucceeded({ page, response }));
  } catch (error) {
    yield put(fetchNotificationFailed({ error }));
  }
}


/**
* Refresh token
*/
export function refreshToken(token) {
  const data = {
    refresh_token: token
  }

  return axios({
    method: "POST",
    url: `${AUTHORIZE_URL}/refresh`,
    data
  });
}
//logout

export const logoutUser = createAction(LOGOUT_USER);

function* logoutUserSaga(clearToken) {
  const logoutAPI = () => {
    return axios({
      method: 'DELETE',
      url: `${usersApi}/users/logout`
    }).then(() => {
      window.parent.postMessage({
      type: "LOG_OUT",
      }, '*');
    });
  }

  try {
    if(clearToken.payload){
       AuthService.clearAccessToken();
    }

    
    const response = yield call(logoutAPI);
  } catch (error) {
   console.log(error);
  } finally {
    AuthService.clearAccessToken();
    window.parent.postMessage({
      type: "LOG_OUT",
      }, '*');
  }
}

export default function* userSaga() {
  yield takeLatest(FETCHING_USER_ACCOUNT_REQUEST, fetchUserAccountSaga);
  yield takeLatest(FETCHING_USER_PROFILE, fetchUserProfileSaga);
  yield takeLatest(FETCHING_NOTIFICATIONS, fetchNotificationSaga);
  yield takeLatest(LOGOUT_USER, logoutUserSaga);
};

